export default __webpack_public_path__ + "static/media/1D3655A0-C5E5-464D-BEDA-FA6F5BEB1627.48372ecc.jpeg";